// extracted by mini-css-extract-plugin
export var childrenContainer = "_dj-0";
export var virtualScrollArea = "_dj-1";